export default __webpack_public_path__ + "static/media/logo.fcb5fcda.png";